import { Chips, type IChipsOption } from '@cian/ui-kit';

import { clsx } from 'clsx';
import { type FC, type JSX } from 'react';

import { Map } from 'shared/containers/Map';

import { LayoutBlock } from '../LayoutBlock';

import type { IPikProjectsItemViewModel } from './external/models/PikProjectsItemViewModel';
import { Filters } from './internal/components/Filters';
import { ResidentialComplexesListContainer } from './internal/components/ResidentialComplexesList';

import styles from './PikProjects.css';

const title = 'Проекты';

type PikProjectsProps = {
  chipsOptions: IChipsOption[];
  activePikProjectsItem: IPikProjectsItemViewModel;
  onChange: (value: string[]) => void;
};

export const PikProjects: FC<PikProjectsProps> = ({ chipsOptions, activePikProjectsItem, onChange }) => {
  return (
    <LayoutBlock
      id="projects"
      rightAdornment={
        <div className={styles['right-adornment']}>
          <Chips<string>
            dataTestId="projects-chips"
            options={chipsOptions}
            value={[activePikProjectsItem.chipsOption.value]}
            onChange={onChange}
          />
        </div>
      }
      sectionTabTitle={title}
      title={<div className={styles['title']}>{title}</div>}
    >
      <div
        className={clsx(styles['container'], styles[`container--${activePikProjectsItem.type}`])}
        data-testid="pik-projects-container"
      >
        <div className={styles['filters-wrapper']} data-testid="filters-wrapper">
          <Filters />
        </div>
        <div className={styles['content']} data-testid="content-wrapper">
          {((): JSX.Element => {
            switch (activePikProjectsItem.type) {
              case 'map':
                return <Map />;
              case 'list':
                return <ResidentialComplexesListContainer />;
            }
          })()}
        </div>
      </div>
    </LayoutBlock>
  );
};
